import { getRgObjectsOfType as t, RG_TYPE as r } from "@project-rouge/rg-core";
import { getVerticalWallArea as i } from "./index59.js";
import { isAmenityTechSpace as a } from "../../queries/index.js";
const l = (e) => i(t(e, [r.TechnicalSpace]).filter(a));
export {
  l as getAmenitiesWallArea
};
//# sourceMappingURL=index4.js.map
